import socketio from "socket.io-client";
import React from "react";

const socketCon = process.env.REACT_APP_API || "";
export const socket = socketio.connect(socketCon);
export const SocketContext = React.createContext();
